export const Modal = {
  content: '',
  active: false,
  open(content) {
    this.content = content;
    this.active = true;
    document.querySelector('#modal a').focus();

    // Add global event listener to set cookies when modal is closed
    const event = new CustomEvent('modalOpened');
    window.dispatchEvent(event, {
      bubbles: true
    });
  },
  close() {
    // Kill modal contents after fade out
    this.active = false;
    setTimeout(() => {
      this.content = '';
    }, 300);

    // Add global event listener to set cookies when modal is closed
    const event = new CustomEvent('modalClosed');
    window.dispatchEvent(event, {
      bubbles: true
    });
  }
};
